//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    BRAND_DELETE_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    brandDeleteResult,
} from 'Redux/actions';


function* deleteBrand({ payload }) {
    try {
        let QUERY = `
            mutation deleteBrand ($id: Int!) {
                result: deleteBrand (id: $id)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(brandDeleteResult({ delete: data?.result }))
        } else yield put(brandDeleteResult({ error: 'delete-brand' }))

    } catch (exc) {
        yield put(brandDeleteResult({ error: exc.error }))
        ExceptionManager(exc, 'Modules/brands/views/.components/deleteBrand/redux/saga', 'deleteBrand');
    }
}

function* watchBrandRequests() {
    yield takeEvery(BRAND_DELETE_REQUEST, deleteBrand);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchBrandRequests)
    ]);
}